import controller from './controller';
import template from './template.html';

const controllerAs = 'optionSelectCtrl';
const bindings = {
  ngModel: '<',
  ngList: '<',
  ngGroups: '<',
  ngProp: '<',
  ngCallback: '&',
  ngLabel: '<',
  ngHelpBlock: '<',
  ngRequired: '<',
  ngPlaceholder: '<',
  ngDisabled: '='
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/forms/optionSelect/index.js